import React from "react";
import styles from "./footer.module.css";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import CookiesConsent from "../cookies_consent/cookies_consent";
import UnknownIcon from "../../images/unknown_icon.svg";
import { getSettings } from "../../services/selectors";

function Footer() {

  const getContacts = store => store.contacts;
  const { emails, phones, socials } = useSelector(getContacts);
  const settings = useSelector(getSettings);

  return (
    <footer className={`${styles.footer}`}>
      <CookiesConsent />
      <div className={styles.container}>
        <div className={`${styles.column}`}>
          <h3 className={styles.column_title}>Контакты</h3>
          {phones.length > 0 &&
            <ul className={styles.list}>
              {phones.map(phone =>
                <li key={phone.id}>
                  <Link to={`tel:${phone.federal_num}`} className={styles.link}>
                    <span style={{'fontWeight': 500}}>{phone.num}</span> {phone.name}
                  </Link>
                </li>
              )}
            </ul>
          }
          {emails.length > 0 &&
            <ul className={styles.list}>
              {emails.map(email =>
                <li key={email.id}>
                  <Link to={`mailto:${email.email}`} className={styles.link}>
                  <span style={{'fontWeight': 500}}>{email.email}</span> {email.name}
                  </Link>
                </li>
              )}
            </ul>
          }
        </div>
        <div className={styles.column}>
          {
            socials.length > 0 &&
            <div className={`${styles.column}`}>
              <h3 className={styles.column_title}>Социальные сети</h3>
              <ul className={styles.list_socials}>
                {
                  socials.map(social =>
                    <li key={social.id}>
                      <Link to={social.link} className={styles.link_socials} target="_blank">
                        <img src={social.icon ? social.icon : UnknownIcon} alt={social.name} className={styles.img}/>
                        {social.name}
                      </Link>
                    </li>
                  )
                }
              </ul>
            </div>
          }
        </div>

        <div className={`${styles.column}`}>
          <h3 className={styles.column_title}>Правовая информация</h3>
          <ul className={styles.list}>
            <li>
              <Link to='/agreement' className={styles.link}>
                Пользовательское соглашение
              </Link>
            </li>
            <li>
              <Link to='/personal-data' className={styles.link}>
                Политика обработки персональных данных
              </Link>
            </li>
            <li>
              <Link to='/cookie' className={styles.link}>
                Политика использования файлов Cookie
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <p className={styles.under_text}>
        {`${settings.company_seller.name}, ИНН ${settings.company_seller.inn}`}
      </p>
      <p className={styles.under_text}>
        Все цены на товары на сайте указаны без НДС в связи с применением УСН.
        Обращаем ваше внимание, что цены на товары не являются публичной офертой.
        Информация о товаре и ценах носит исключительно информационный характер.
        Актуальную стоимость и наличие товара просьба уточнять дополнительно.
      </p>
      <p className={styles.under_text}>
        Информация, представленная на сайте, является интеллектуальной собственностью!
        Любое незаконное использование или копирование преследуется по закону!
      </p>
    </footer>
  );
}

export default Footer;
